/**
 * Configuration of available basemaps for each customer
 * If a customer orgId is not listed, all basemaps except 'basemap' are available
 */

import { tenantOrgIds } from '@/customers/tenantOrgIds'

export const DEFAULT_BASEMAPS = ['imageryHybrid', 'darkGrayCanvas', 'topo', 'street', 'lightGrayCanvas', 'streetsNight']
export const DEFAULT_MT_NAF_BASEMAPS = [
  'hybridUS',
  'imageryUS',
  'streetsNightUS',
  'streetsUS',
  'lightGrayCanvasUS',
  'darkGrayCanvasUS',
  'topoUS'
]

export const basemapsByCustomer: Record<string, string[]> = {
  [tenantOrgIds.morocco]: DEFAULT_MT_NAF_BASEMAPS,
  [tenantOrgIds.algeria]: DEFAULT_MT_NAF_BASEMAPS,
  [tenantOrgIds.tunisia]: DEFAULT_MT_NAF_BASEMAPS,
  [tenantOrgIds.usafricom]: DEFAULT_MT_NAF_BASEMAPS
}

/**
 * Get available basemap IDs for a customer
 */
export const getAvailableBasemapIds = (orgId?: string): string[] => {
  if (!orgId) return DEFAULT_BASEMAPS
  return basemapsByCustomer[orgId] || DEFAULT_BASEMAPS
}
